export const FILES_URL = "/files";
export const DATA_URL = "/data";
export const SESSIONS_URL = "/sessions";
export const AUTHENTICATE_URL = "/authenticate";
export const ACCOUNT_KEY_URL = "/account-key";
export const LOGIN_URL = "/login";
export const ERROR_URL = "/404";
export const EMAIL_VERIFICATION_URL = "/email-verification";
export const ASSISTANT_URL = "/assistant";
export const QA_URL = "/q&a";
export const PID_URL = "/pid";
export const CHECKLIST_DIAGRAM_MODE_URL = "/checklist-diagram/messages";
export const DATA_ANALYSIS_MODE_URL = "/data-analysis/sessions";
export const BOOKMARKS_URL = "/saved";
export const HISTORY_URL = "/history";
export const AI_SEARCH_URL = "/search";
export const VIEW_FILE_URL = "/view-file";
export const DATA_EXPLORER_URL = "/data/data-explorer";
export const DATA_MANAGEMENT_URL = "/data/data-management";
export const ACCOUNT_URL = "/account";
export const SAVED_URL = "/saved";
export const FEEDBACK_URL = "/feedback";
export const WORKPLACE_URL = "/workplace";
export const WORKPLACE_DASHBOARD_URL = "/workplace/dashboard";
export const WORKPLACE_EVALS_URL = "/workplace/evals";
export const WORKPLACE_GENERAL_SETTINGS_URL = "/workplace/general-settings";
export const WORKPLACE_USERS_URL = "/workplace/users";
export const WORKPLACE_ROLE_ACCESS_URL = "/workplace/role-access";
export const WORKPLACE_INTEGRATIONS_URL = "/workplace/integrations";
export const WORKPLACE_BILLING_AND_SUBSCRIPTION_URL =
  "/workplace/billing-and-subscription";
export const WORKPLACE_AUDIT_LOGS_URL = "/workplace/audit-logs";
